import * as contentful from "contentful";
import { EntryCollection } from "contentful";

const CONTENTFUL_SPACE = <string>process.env.REACT_APP_CONTENTFUL_SPACE;
const CONTENTFUL_ACCESS_TOKEN = <string>(
  process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN
);
const CONTENTFUL_ENVIRONMENT = <string>(
  process.env.REACT_APP_CONTENTFUL_ENVIRONMENT
);

export const getContentfulClient = (_isPreview?: boolean) =>
  contentful.createClient({
    space: CONTENTFUL_SPACE,
    accessToken: CONTENTFUL_ACCESS_TOKEN,
    environment: CONTENTFUL_ENVIRONMENT,
  });

export const fetchFromContentful = async <T>({
  queryKey,
}: {
  queryKey: unknown[];
}): Promise<EntryCollection<T>> => {
  const result: EntryCollection<T> = await getContentfulClient(
    queryKey[2] as boolean,
  ).getEntries(queryKey[1]);
  if (result.items.length >= 999) {
    throw new Error("Unable to fetch all contentful");
  }
  return result;
};
